import MicroModal from 'micromodal';

export default () => {
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-installments-modal]')) {
      e.preventDefault();
      const trigger = e.target.closest('[data-open-installments-modal]');
      const isShopPay = trigger.dataset.openInstallmentsModal === 'shoppay';
      const isAfterpay = trigger.dataset.openInstallmentsModal === 'afterpay';
      const modal = document.querySelector('[data-installments-modal]');

      if (!modal) return;

      MicroModal.show(modal.id, {
        disableScroll: true,
        awaitOpenAnimation: true,
        awaitCloseAnimation: true,
        onShow: (modal) => {
          // Reset visibility
          modal.querySelectorAll('[data-installments-icon-shoppay], [data-installments-icon-afterpay], [data-installments-desc-shoppay], [data-installments-desc-afterpay]').forEach(el => el.classList.add('visually-hidden'));

          if (isShopPay) {
            modal.querySelector('[data-installments-icon-shoppay]')?.classList.remove('visually-hidden');
            modal.querySelector('[data-installments-desc-shoppay]')?.classList.remove('visually-hidden');
          } else if (isAfterpay) {
            modal.querySelector('[data-installments-icon-afterpay]')?.classList.remove('visually-hidden');
            modal.querySelector('[data-installments-desc-afterpay]')?.classList.remove('visually-hidden');
          }
        },
        onClose: (modal) => {
          // [ADA] Focus the product-free-shipping element
          const installmentsTrigger = document.querySelector('.product-free-shipping');
          if (installmentsTrigger) {
            installmentsTrigger.focus();
          }
        }
      });
    }
  });
};
